const VIPValidation = {
    Scan: "scan-qr",
    MobileNum: "mobile-no",
    VIPCardNum: "fleet-card",
  };
  
  export default VIPValidation;
  